module.exports = __webpack_public_path__ + "b82aa9c81cf3bcc7b0903e972c8f548d.gif";